import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

interface ItemActionsProps {
  isRenameOpen: boolean;
  isDeleteOpen: boolean;
  itemType: string;
  onRenameClose: () => void;
  onDeleteClose: () => void;
  onRename: (newTitle: string) => void;
  onDelete: () => void;
  initialTitle?: string;
  onModalStateChange?: (isOpen: boolean) => void;
}

export const ItemActions: React.FC<ItemActionsProps> = ({
  isRenameOpen,
  isDeleteOpen,
  itemType,
  onRenameClose,
  onDeleteClose,
  onRename,
  onDelete,
  initialTitle = "",
  onModalStateChange,
}) => {
  const [newTitle, setNewTitle] = useState(initialTitle);

  useEffect(() => {
    if (isRenameOpen) {
      setNewTitle(initialTitle);
    }
  }, [initialTitle, isRenameOpen]);

  const handleRenameClose = () => {
    setNewTitle(initialTitle);
    onRenameClose();
  };

  return (
    <>
      <Dialog
        open={isRenameOpen}
        onOpenChange={(open) => {
          handleRenameClose();
          onModalStateChange?.(open);
        }}
      >
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Rename {itemType}</DialogTitle>
          </DialogHeader>
          <Input
            className="border rounded-md"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder="Enter new name"
          />
          <DialogFooter>
            <Button variant="outline" onClick={onRenameClose}>
              Cancel
            </Button>
            <Button
              onClick={() => onRename(newTitle.trim())}
              disabled={!newTitle.trim()}
            >
              Rename
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={isDeleteOpen}
        onOpenChange={(open) => {
          onDeleteClose();
          onModalStateChange?.(open);
        }}
      >
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Delete {itemType}</DialogTitle>
          </DialogHeader>
          <p>
            Are you sure you want to delete this {itemType.toLowerCase()}? This
            action cannot be undone.
          </p>
          <DialogFooter>
            <Button variant="outline" onClick={onDeleteClose}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={onDelete}>
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
